export const Specializzaziones = [
   "ADOLESCENTOLOGIA PREVENTIVA E CLINICA"
,"ALLERGOLOGIA"
,"ALLERGOLOGIA E IMMUNOEMATOLOGIA CLINICA"
,"ALLERGOLOGIA E IMMUNOLOGIA"
,"ALLERGOLOGIA E IMMUNOLOGIA CLINICA"
,"ALLERGOLOGIA ED IMMUNOLOGIA CLINICA"
,"ALLERGOLOGIA ED IMMUNOLOGIA PEDIATRICA"
,"ALLERGOLOGIA ED IMMUNUNOLOGIA CLINICA"
,"ANALISI CHIMICO CLINICHE"
,"ANALISI CHIMICO CLINICHE E MICROBIOLOGICHE"
,"ANALISI CHIMICO-CLINICHE DI LABORATORIO"
,"ANALISI CHIMICO-CLINICHE E MICROBIOLOGIA"
,"ANALISI CLINICHE"
,"ANALISI CLINICHE DI LABORATORIO"
,"ANALISI CLINICHE E DI LABORATORIO"
,"ANATOMIA E ISTOL. PATOL. E TECNICHE DI LABORATORIO"
,"ANATOMIA E ISTOLOGIA PATOLOGICA"
,"ANATOMIA ED ISTOLOGIA PATOL. ED ANALISI CLINICHE"
,"ANATOMIA PATOLOGICA"
,"ANATOMIA PATOLOGICA E ISTOLOGIA PATOLOGICA"
,"ANATOMIA PATOLOGICA E TECNICHE DI LABORATORIO"
,"ANATOMIA UMANA E ISTOLOGIA PATOLOGICA"
,"ANATOMIA UMANA NORMALE"
,"ANDROLOGIA"
,"ANESTESIA"
,"ANESTESIA E RIANIMAZIONE"
,"ANESTESIA E RIANIMAZIONE TERAPIA ANTALGICA"
,"ANESTESIA RIANIMAZIONE"
,"ANESTESIA, RIANIMAZIONE E TERAPIA INTENSIVA"
,"ANESTESIA, RIANIMAZIONE, TERAPIA INTENSIVA E DEL DOLORE"
,"ANESTESIOLOGIA"
,"ANESTESIOLOGIA E RIANIMAZIONE"
,"ANESTESIOLOGIA RIANIMAZIONE E TERAPIA INTENSIVA"
,"ANGIOLOGIA"
,"ANGIOLOGIA E CHIRURGIA VASCOLARE"
,"ANGIOLOGIA MEDICA"
,"APPARATO CARDIOVASCOLARE"
,"APPARATO DIGERENTE"
,"APPARATO RESPIRATORIO"
,"AUDIOLOGIA"
,"AUDIOLOGIA E FONIATRIA"
,"BIOCHIMICA CLINICA"
,"BIOCHIMICA E CHIMICA CLINICA"
,"BIOCHIMICA FISICA"
,"BIOCLINICA E CHIMICA CLINICA"
,"BIOLOGIA CLINICA"
,"BIOLOGIA GENERALE"
,"BIOMETRIA E STATISTICA MEDICA"
,"CARDIOANGIOCHIRURGIA"
,"CARDIO-ANGIO-CHIRURGIA"
,"CARDIOCHIRURGIA"
,"CARDIOLOGIA"
,"CARDIOLOGIA E MALATTIA DEI VASI"
,"CARDIOLOGIA E MALATTIE DEI VASI"
,"CARDIOLOGIA E MALATTIE DELL'APPARATO CARDIOVASCOLARE"
,"CARDIOLOGIA E MALATTIE VASCOLARI"
,"CARDIOLOGIA E REUMATOLOGIA"
,"CARDIO-REUMATOLOGIA"
,"CARDIOVASCOLARE E MALATTIE DEI VASI"
,"CHEMIOTERAPIA"
,"CHIMICA APPLICATA ALL'IGIENE"
,"CHINESITERAPIA FISIOTERAPIA RIABIL.E GINNASTICA IN ORTOPEDIA"
,"CHINESITERAPIA FISIOTERAPIA RIABIL.E GINNASTICA MEDICA IN ORTOPEDIA"
,"CHIRURGIA"
,"CHIRURGIA APPARATO DIGERENTE"
,"CHIRURGIA APPARATO DIGERENTE ED ENDOSCOPIA DIGESTIVA"
,"CHIRURGIA APPARATO DIGERENTE ED ENDOSCOPIA DIGESTIVA CHIRURG."
,"CHIRURGIA APPARATO DIGERENTE ENDOSCOPIA DIGESTIVA"
,"CHIRURGIA APPARATO DIGERENTE ENDOSCOPIA DIGESTIVA CHIR."
,"CHIRURGIA CARDIACA"
,"CHIRURGIA CARDIOVASCOLARE"
,"CHIRURGIA DELLA MANO"
,"CHIRURGIA DELLA MANO E MICROCHIRURGIA RICOSTRUTTIV."
,"CHIRURGIA DELL'APPARATO DIGERENTE"
,"CHIRURGIA DELL'APPARATO DIGERENTE ED ENDOSCOPIA CHIRURGICA"
,"CHIRURGIA DELL'APPARATO DIGERENTE ED ENDOSCOPIA DIGESTIVA"
,"CHIRURGIA DELL'APPARATO DIGERENTE ED ENDOSCOPIA DIGESTIVA CHIRURGICA"
,"CHIRURGIA DELL'APPARATO DIGESTIVO"
,"CHIRURGIA DELL'INFANZIA"
,"CHIRURGIA D'URGENZA"
,"CHIRURGIA D'URGENZA E DI PRONTO SOCCORSO"
,"CHIRURGIA D'URGENZA E PRONTO SOCCORSO"
,"CHIRURGIA E PROPED.CLIN."
,"CHIRURGIA GENERALE"
,"CHIRURGIA GENERALE D'URGENZA E PRONTO SOCCORSO"
,"CHIRURGIA GENERALE E TERAPIA CHIRURGICA"
,"CHIRURGIA GENERALE II- IND.CHIR.GEN."
,"CHIRURGIA GENERALE SECONDA"
,"CHIRURGIA GENERALE VASCOLARE"
,"CHIRURGIA INFANTILE"
,"CHIRURGIA MAXILLO-FACCIALE"
,"CHIRURGIA OCULARE"
,"CHIRURGIA ODONTOSTOMATOLOGICA"
,"CHIRURGIA ONCOLOGICA"
,"CHIRURGIA ORALE"
,"CHIRURGIA ORTOPEDICA"
,"CHIRURGIA ORTOPEDICA E TRAUMATOLOGIA"
,"CHIRURGIA PEDIATRICA"
,"CHIRURGIA PLASTICA"
,"CHIRURGIA PLASTICA E RICOSTRUTTIVA"
,"CHIRURGIA PLASTICA RICOSTRUTTIVA ED ESTETICA"
,"CHIRURGIA SPECIALE ODONTOSTOMATOLOGICA"
,"CHIRURGIA SPERIMENTALE"
,"CHIRURGIA SPERIMENTALE E MICROCHIRURGIA"
,"CHIRURGIA SPERIMENTALE MICROCHIRURGIA"
,"CHIRURGIA TORACICA"
,"CHIRURGIA TORACICO-POLMONARE"
,"CHIRURGIA TORACO-POLMONARE"
,"CHIRURGIA VASCOLARE"
,"CINESITERAPIA FISIOTERAPIA RIABILITAZIONE E GINNASTICA MEDICA IN ORTOPEDIA"
,"CITOGENETICA UMANA"
,"CLINICA CHIRURGICA"
,"CLINICA DELLA TUBERCOLOSI E DELLE MALATTIE DELLE VIE RESPIRATORIE"
,"CLINICA DELLE MALATTIE NERVOSE MENTALI"
,"CLINICA DERMATOLOGICA"
,"CLINICA DERMATOLOGICA E VENEROLOGIA"
,"CLINICA DERMOSIFILOPATICA"
,"CLINICA MALATTIE INFETTIVE"
,"CLINICA MALATTIE INFETTIVE TROPICALI E SUBTROPICALI"
,"CLINICA MALATTIE NERVOSE"
,"CLINICA MALATTIE VIE RESPIRATORIE"
,"CLINICA NEUROLOGIA"
,"CLINICA NEUROLOGICA E PSICHIATRICA"
,"CLINICA NEUROPSICHIATRICA"
,"CLINICA OCULISTICA"
,"CLINICA ODONTOIATRICA E STOMATOLOGIA"
,"CLINICA ORTOPEDICA E TRAUMATOLOGIA APPARATO MOTORE"
,"CLINICA ORTOPEDICA E TRAUMATOLOGICA"
,"CLINICA OSTETRICA E GINECOLOGICA"
,"CLINICA OTORINOLARINGOIATRICA"
,"CLINICA PEDIATRICA"
,"CLINICA PSICHIATRICA"
,"CRIMINOLOGIA CLINICA"
,"CRIMINOLOGIA CLINICA E PSICHIATRIA FORENSE"
,"CRIMINOLOGIA CLINICA PSICHIATRIA FORENSE"
,"DERMATOLOGIA"
,"DERMATOLOGIA E SIFILOGRAFIA"
,"DERMATOLOGIA E VENEREOLOGIA"
,"DERMATOLOGIA E VENEREOLOGIA [ORDIN. 2015]"
,"DERMATOLOGIA E VENEROLOGIA"
,"DERMOSIFILOPATIA"
,"DERMOSIFILOPATIA E VENEROLOGIA"
,"DERMOSIFILOPATICA"
,"DIABETOLOGIA"
,"DIABETOLOGIA E MALATTIE DEL RICAMBIO"
,"DIAGNOSTICA DI LABORATORIO"
,"DIAGNOSTICA RADIOLOGICA"
,"DIETOLOGIA"
,"DISCIPLINE REGOLATORIE"
,"ECOGRAFIA"
,"EMATOLOGIA"
,"EMATOLOGIA CLINICA E DI LABORATORIO"
,"EMATOLOGIA CLINICA E TECNICHE DI LABORATORIO"
,"EMATOLOGIA GENERALE"
,"EMATOLOGIA GENERALE E CLINICA DI LABORATORIO"
,"EMATOLOGIA GENERALE E TECNICHE DI LABORATORIO"
,"ENDOCRINOCHIRURGIA"
,"ENDOCRINO-CHIRURGIA"
,"ENDOCRINOLOGIA"
,"ENDOCRINOLOGIA E MALATTIE DEL METABOLISMO"
,"ENDOCRINOLOGIA E MALATTIE DEL RICAMBIO"
,"ENDOCRINOLOGIA E MALATTIE DEL RICAMBIO AD INDIRIZZO ENDOCRINOLOGIA"
,"ENDOCRINOLOGIA E MALATTIE METABOLICHE"
,"ENDOCRINOLOGIA E MALATTIE RICAMBIO"
,"ENDOCRINOLOGIA E MEDICINA COSTITUZIONALE"
,"ENDOCRINOLOGIA MALATTIE DEL RICAMBIO E DIABETOLOGIA"
,"ENDOCRINOLOGIA SPERIMENTALE"
,"FARMACOLOGIA"
,"FARMACOLOGIA APPLICATA"
,"FARMACOLOGIA APPLICATA ALL' INDUSTRIA"
,"FARMACOLOGIA CLINICA"
,"FARMACOLOGIA E FARMACOGNOSIA"
,"FARMACOLOGIA E TOSSICOLOGIA"
,"FARMACOLOGIA E TOSSICOLOGIA CLINICA"
,"FARMACOLOGIA MEDICA"
,"FARMACOLOGIA N.O. IND. CHEMIOTERAPIA"
,"FARMACOLOGIA PER MEDICINA"
,"FARMACOLOGIA SPERIMENTALE"
,"FISIATRIA"
,"FISIOCHINESITERAPIA"
,"FISIOCHINESITERAPIA ORTOPEDICA"
,"FISIOCINESITERAPIA ORTOPEDICA"
,"FISIOLOGIA E SCIENZA DELLA ALIMENTAZIONE"
,"FISIOLOGIA ED IGIENE DEL LAVORO"
,"FISIOLOGIA UMANA E MALATTIA APPARATO RESPIRATORIO"
,"FISIOPATOLOGIA DELLA RIPRODUZIONE UMANA ED EDUCAZIONE DEMOGRAFICA"
,"FISIOPATOLOGIA E FISIOKINESI RESPIRATORIA"
,"FISIOPATOLOGIA E FISIOKINESITERAPIA RESPIRATORIA"
,"FISIOPATOLOGIA E TERAPIA DEL DOLORE"
,"FISIOPATOLOGIA FISIOCHINESITERAPIA RESPIRATORIA"
,"FISIOPATOLOGIA RESPIRATORIA"
,"FISIOPATOLOGIA RIPRODUZIONE UMANA ED EDUCAZIONE DEMOGRAFICA"
,"FISIOTERAPIA"
,"FONIATRIA"
,"GASTROENTEROLOGIA"
,"GASTRO-ENTEROLOGIA"
,"GASTROENTEROLOGIA E MALATTIA APPARATO DIGERENTE"
,"GASTROENTEROLOGIA ED ENDOSCOPIA DIGESTIVA"
,"GASTROENTEROLOGIA ENDOSCOPIA DIGESTIVA"
,"GENETICA APPLICATA"
,"GENETICA MEDICA"
,"GERIATRIA"
,"GERIATRIA E GERONTOLOGIA"
,"GERIATRIA STATUTARIO"
,"GERONTOLOGIA E GERIATRIA"
,"GINECOLOGIA"
,"GINECOLOGIA E OSTETRICIA"
,"GINECOLOGIA ED OSTETRICIA"
,"GINECOLOGIA ED OSTETRICIA NN.O. II FACOLTA'"
,"GINECOLOGIA OSTETRICIA"
,"IDROCLIMATOLOGIA E CLINICA TERMALE"
,"IDROCLIMATOLOGIA MEDICA"
,"IDROCLIMATOLOGIA MEDICA E CLINICA TERMALE"
,"IDROLOGIA MEDICA"
,"IDROLOGIA MEDICA E CLIMATOLOGIA E TALASSOTERAPIA"
,"IDROLOGIA MEDICA E MEDICINA TERMALE"
,"IDROLOGIA, CLIMATOLOGIA, TALASSOTERAPIA"
,"IGIENE"
,"IGIENE E BATTERIOLOGIA"
,"IGIENE E MEDIC.PREVENT.ORIENT.SAN.PUBBLICA"
,"IGIENE E MEDICINA PREVENTIVA"
,"IGIENE E MEDICINA PREVENTIVA CON ORIENTAMENTO DI DIREZIONE OSPEDALIERA"
,"IGIENE E MEDICINA PREVENTIVA DIREZIONE OSPEDALIERA"
,"IGIENE E MEDICINA PREVENTIVA EPIDEM.E SAN.PUB."
,"IGIENE E MEDICINA PREVENTIVA IGIENE E ORGANIZZAZIONE SERVIZI OSPEDALIERI"
,"IGIENE E MEDICINA PREVENTIVA ORDINAMENTO 2009"
,"IGIENE E MEDICINA PREVENTIVA ORIENTAMENTO DI SANITA' PUBBLICA"
,"IGIENE E MEDICINA PREVENTIVA ORIENTAMENTO DIREZIONE OSPEDALIERA"
,"IGIENE E MEDICINA PREVENTIVA ORIENTAMENTO EPIDEMIOLOGIA E SANITA' PUBBLICA"
,"IGIENE E MEDICINA PREVENTIVA ORIENTAMENTO IGIENE E DIREZIONE OSPEDALIERA"
,"IGIENE E MEDICINA PREVENTIVA ORIENTAMENTO IGIENE E DIREZIONE OSPITALIERA"
,"IGIENE E MEDICINA PREVENTIVA ORIENTAMENTO IGIENE E ORGANIZZAZIONE SERVIZI OSPEDALIERI"
,"IGIENE E MEDICINA PREVENTIVA ORIENTAMENTO IGIENE TEC.E DIREZIONE OSP."
,"IGIENE E MEDICINA PREVENTIVA ORIENTAMENTO SCOLASTICO"
,"IGIENE E MEDICINA PREVENTIVA ORIENTAMENTO TECNICA E DIREZIONE OSPEDALIERA"
,"IGIENE E MEDICINA PREVENTIVA ORIENTAMENTO TECNICA OSPED."
,"IGIENE E MEDICINA PREVENTIVA-ORIENTAMENTO DI SANITA'"
,"IGIENE E MEDICINA PREVENTIVA-ORIENTAMENTO IGIENE E MED.SCOL."
,"IGIENE E MEDICINA PREVENTIVA-ORIENTAMENTO IGIENE LAVORO"
,"IGIENE E MEDICINA PREVENTIVA-ORIENTAMENTO LABORATORIO"
,"IGIENE E MEDICINA PREVENTIVA-ORIENTAMENTO ORG. S.SANITARI"
,"IGIENE E MEDICINA PREVENTIVA-ORIENTAMENTO ORGANIZZAZIONE DEI SERVIZI SANITARI DI BASE"
,"IGIENE E MEDICINA SCOLASTICA"
,"IGIENE E MEDICINA SOCIALE"
,"IGIENE E SANITA' PUBBLICA"
,"IGIENE E TECNICA OSPEDALIERA"
,"IGIENE ED EPIDEMIOLOGIA"
,"IGIENE GENERALE E SPECIALE"
,"IGIENE MEDICA PREVENTIVA IGIENE MEDICA SCOLASTICA"
,"IGIENE MEDICINA PREVENTIVA ORIENTAMENTO MEDICINA SCOLASTICA"
,"IGIENE MENTALE"
,"IGIENE TECNICA E DIREZIONE OSPEDALIERA"
,"IMMUNOEMATOLOGIA"
,"IMMUNOEMATOLOGIA E TRASFUSIONE"
,"IMMUNOLOGIA"
,"IMMUNOLOGIA CLINICA"
,"IMMUNOLOGIA CLINICA ED ALLERGOLOGIA"
,"IPNOSI E PSICOTERAPIA ERICKSONIANA"
,"ISTOCHIMICA NORMALE E PATOLOGICA"
,"LEPROLOGIA E DERMATOLOGIA TROPICALE"
,"MALATTIE APPARATO CARDIOVASCOLARE"
,"MALATTIE APPARATO DIGERENTE E ENDOSCOPIA"
,"MALATTIE APPARATO DIGERENTE E RICAMBIO"
,"MALATTIE APPARATO DIGERENTE ED ENDOSCOPIADIGESTIVA"
,"MALATTIE APPARATO RESPIRATORIO"
,"MALATTIE APPARATO RESPIRATORIO E TISIOLOGIA"
,"MALATTIE CARDIOVASCOLARI"
,"MALATTIE CARDIOVASCOLARI E REUMATICHE"
,"MALATTIE DEL FEGATO"
,"MALATTIE DEL FEGATO E DEL RICAMBIO"
,"MALATTIE DEL FEGATO E RICAMBIO"
,"MALATTIE DEL LAVORO"
,"MALATTIE DEL RENE DEL SANGUE E DEL RICAMBIO"
,"MALATTIE DEL RENE SANGUE E RICAMBIO"
,"MALATTIE DEL RICAMBIO E DELL'APPARATO DIGERENTE"
,"MALATTIE DEL SANGUE E RICAMBIO"
,"MALATTIE DEL TUBO DIGERENTE DEL SANGUE E RICAMBIO"
,"MALATTIE DELL'APPARATO CARDIOVASCOLARE"
,"MALATTIE DELL'APPARATO DIGERENTE"
,"MALATTIE DELL'APPARATO DIGERENTE DELLA NUTR.E DEL RI."
,"MALATTIE DELL'APPARATO RESPIRATORIO"
,"MALATTIE ENDOCRINE E METABOLICHE"
,"MALATTIE INFETTIVE"
,"MALATTIE INFETTIVE E TROPICALI"
,"MALATTIE INFETTIVE TROPICALI E SUB TROPICALI"
,"MALATTIE NERVOSE"
,"MALATTIE NERVOSE E MENTALI"
,"MALATTIE POLMONARI E TISIOLOGIA"
,"MALATTIE TROPICALI E SUB TROPICALI"
,"MEDICI LABORATORISTI"
,"MEDICICINA DI LABORATORIO-BIOCHIMICA CLINICA E BIOLOGIA MOLECOLARE CLINICA"
,"MEDICINA AERONAUTICA E SPAZIALE"
,"MEDICINA DEL LAVORO"
,"MEDICINA DEL LAVORO 1"
,"MEDICINA DEL NUOTO ATTIVITA' SUBACQUEE"
,"MEDICINA DEL NUOTO E ATTIVITA' SUBACQUEE"
,"MEDICINA DEL NUOTO E DELLE ATTIVITA' SUBACQUEE"
,"MEDICINA DELLO SPORT"
,"MEDICINA DELLO SPORT E DELL'ESERCIZIO FISICO"
,"MEDICINA D'EMERGENZA-URGENZA"
,"MEDICINA DI COMUNITA'"
,"MEDICINA DI COMUNITA' E DELLE CURE PRIMARIE"
,"MEDICINA DI LABORATORIO- BIOCHIMICA CLINICA E BIOLOGIA MOLECOLARE CLINICA"
,"MEDICINA DI LABORATORIO-BIOCHIMICA CLINICA"
,"MEDICINA E IGIENE SCOLASTICA"
,"MEDICINA FISICA"
,"MEDICINA FISICA E RIABILITATIVA"
,"MEDICINA FISICA E RIABILITAZIONE"
,"MEDICINA GENERALE"
,"MEDICINA GENERALE E INTERNA"
,"MEDICINA INTERNA"
,"MEDICINA INTERNA E MEDICINA D'URGENZA"
,"MEDICINA LEGALE"
,"MEDICINA LEGALE DEL LAVORO"
,"MEDICINA LEGALE E DELLE ASSICURAZIONI"
,"MEDICINA NUCLEARE"
,"MEDICINA NUCLEARE [ORDIN.2009]"
,"MEDICINA PREVENTIVA"
,"MEDICINA PREVENTIVA DEI LAVORATORI E PSICOTECNICA"
,"MEDICINA SUBACQUA E IPERBARICA"
,"MEDICINA TERMALE"
,"MEDICINA TROPICALE"
,"MEDICINA TROPICALE E SUB TROPICALE"
,"MEDICO LABORATORISTA"
,"MEDICO LABORATORISTA SPECIALISTA IN ANALISI CLINICHE"
,"MEDICO SETTORE LABORATORISTA"
,"MICROBIOLOGIA"
,"MICROBIOLOGIA APPLICATA"
,"MICROBIOLOGIA E VIROLOGIA"
,"MICROBIOLOGIA MEDICA"
,"MICROCHIRURGIA"
,"MICROCHIRURGIA E CHIRURGIA SPERIMENTALE"
,"NEFROLOGIA"
,"NEFROLOGIA E DIALISI"
,"NEFROLOGIA MEDICA"
,"NEONATOLOGIA"
,"NEONATOLOGIA E PATOLOGIA NEONATALE"
,"NEUROCHIRURGIA"
,"NEUROCHIRURGIA INFANTILE"
,"NEUROFISIOLOGIA CLINICA"
,"NEUROFISIOPATOLOGIA"
,"NEUROLOGIA"
,"NEUROLOGIA E PSICHIATRIA"
,"NEUROLOGIA INFANTILE"
,"NEUROPATOLOGIA"
,"NEUROPATOLOGIA E PSICHIATRIA"
,"NEUROPSICHIATRIA"
,"NEUROPSICHIATRIA INFANTILE"
,"NEURORADIOLOGIA"
,"NIPIOLOGIA E PAIDOLOGIA"
,"OCULISTA"
,"OCULISTICA"
,"OCULISTICA E OFTALMOLOGIA"
,"ODONTOGNATODONZIA"
,"ODONTOIATRIA"
,"ODONTOIATRIA E PROTESI DENTALE"
,"ODONTOIATRIA E PROTESI DENTALE O DENTARIA"
,"ODONTOIATRIA E PROTESI DENTARIA"
,"ODONTOIATRIA E STOMATOLOGIA"
,"ODONTOIATRIA PEDIATRICA"
,"ODONTOSTOMATOLOGIA"
,"ODONTOSTOMATOLOGIA-I SC."
,"OFTALMOIATRIA"
,"OFTALMOLOGIA"
,"OFTALMOLOGIA 2^"
,"OFTALMOLOGIA E OCULISTICA"
,"ONCOLOGIA"
,"ONCOLOGIA CLINICA"
,"ONCOLOGIA GENERALE"
,"ONCOLOGIA INDAGINI ONCOLOGICHE E DIAGNOSI PREVENTIVA"
,"ONCOLOGIA MEDICA"
,"ONCOLOGIA NN.OO."
,"ONCOLOGIA ORIENTAMENTO ONCOL.GEN.DIAGNOSTICA E PREV."
,"ONCOLOGIA SPERIMENTALE"
,"ORGANIZZAZIONE SANITARIA E SICUREZZA SOCIALE"
,"ORTODONZIA"
,"ORTODONZIA E GNATOLOGIA"
,"ORTOGNATODONZIA"
,"ORTOGNATODONZIA E FUNZIONE MASTICATORIA"
,"ORTOPEDIA"
,"ORTOPEDIA E TRAUMATOLOGIA"
,"ORTOPEDIA E TRAUMATOLOGIA DELL'APPARATO LOCOMOTORE"
,"ORTOPEDIA E TRAUMATOLOGIA DELL'APPARATO MOTORE"
,"ORTOPEDIA E TRAUMATOLOGIA GENERALE"
,"ORTOPEDIA IND. CHIRURURGIA DELLA MANO E MICROC.ORTOPED."
,"ORTOPEDIA TRAUMATOLOGIA APPARATO MOTORE"
,"OSTETRICIA E GINECOLOGIA"
,"OSTETRICIA E GINECOLOGIA II SC."
,"OTORINOLARINGOIATRIA"
,"OTORINOLARINGOIATRIA CHIRURGIA CERVICO-FACCIALE"
,"OTORINOLARINGOIATRIA E PATOLOGIA CERVICO-FACCIALE"
,"PARASSITOLOGIA"
,"PARASSITOLOGIA MEDICA"
,"PATOLOGIA CLINICA"
,"PATOLOGIA CLINICA E BIOCHIMICA CLINICA"
,"PATOLOGIA CLINICA E DI LABORATORIO"
,"PATOLOGIA DELLA RIPRODUZIONE UMANA"
,"PATOLOGIA E BIOCHIMICA CLINICA"
,"PATOLOGIA GENERALE"
,"PATOLOGIA SPECIALE CHIRURGICA E PROPEDEUTICA CLINICA"
,"PATOLOGIA SPECIALE MEDICA DIMOSTRATIVA"
,"PEDIATRIA"
,"PEDIATRIA E NEONATOLOGIA"
,"PEDIATRIA E PUERICULTURA"
,"PEDIATRIA GENERALE"
,"PEDIATRIA NEONATOLOGIA E TERAPIA INTENSIVA NEONATALE"
,"PEDIATRIA PREVENTIVA E PUERICOLTURA"
,"PEDIATRIA PREVENTIVA E PUERICULTURA"
,"PEDIATRIA PREVENTIVA E PUERICULTURA ORIENTAMENTO NEONATOLOGIA"
,"PEDIATRIA PREVENTIVA E SOCIALE"
,"PEDIATRIA-NEONATOLOGIA E TERAPIA INTENSIVA NEONATOLOGICA"
,"PIANIFICAZIONE E POLITICHE SOCIALI"
,"PNEUMOLOGIA"
,"PNEUMOLOGIA E APPARATO RESPIRATORIO"
,"PNEUMOLOGIA E MALATTIE DELL'APPARATO RESPIRATORIO"
,"PRONTO SOCCORSO E CHIRURGIA D'URGENZA"
,"PRONTO SOCCORSO E TERAPIA D'URGENZA"
,"PSICHIATRIA"
,"PSICHIATRIA E NEUROPATOLOGIA"
,"PSICHIATRIA NN.O II FACOLTA'"
,"PSICHICHIATRIA E PSICOTERAPIA"
,"PSICO PEDAGOGIA"
,"PSICOLOGIA"
,"PSICOLOGIA AD INDIRIZZO MEDICO"
,"PSICOLOGIA CLINICA"
,"PSICOLOGIA CLINICA E PSICOTERAPIA"
,"PSICOLOGIA CLINICA ORIENTAMENTO PSIC.PSICOT.IND.E GRUPPO"
,"PSICOLOGIA DEL CICLO DI VITA"
,"PSICOLOGIA MEDICA"
,"PSICOTERAPIA"
,"PSICOTERAPIA A INDIRIZZO PSICODINAMICO INDIVIDUALE E DI GRUPPO"
,"PSICOTERAPIA A INDIRIZZO PSICOSINTETICO"
,"PSICOTERAPIA AD INDIRIZZO COGNITIVO COMPORTAMENTALE"
,"PSICOTERAPIA AD INDIRIZZO GESTALTICO"
,"PSICOTERAPIA AD INDIRIZZO IPNOSI CLINICA"
,"PSICOTERAPIA AD INDIRIZZO PSICOANALITICO LACANIANO"
,"PSICOTERAPIA AD INDIRIZZO PSICOSOMATICO"
,"PSICOTERAPIA AD INDIRIZZO SISTEMICO-RELAZIONALE"
,"PSICOTERAPIA AD ORIENTAMENTO ADLERIANO"
,"PSICOTERAPIA ANALITICA"
,"PSICOTERAPIA BREVE INTEGRATA"
,"PSICOTERAPIA BREVE STRATEGICA"
,"PSICOTERAPIA COGNITIVA"
,"PSICOTERAPIA COGNITIVA AD INDIRIZZO COSTRUTTIVISTA ED EVOLUTIVO"
,"PSICOTERAPIA COGNITIVA COMPORTAMENTALE IN AMBITO CLINICO E FORENSE"
,"PSICOTERAPIA COGNITIVA E COGNITIVO-COMPORTAMENTALE"
,"PSICOTERAPIA COGNITIVO COMPORTAMENTALE AD INDIRIZZO NEUROPSICOLOGICO"
,"PSICOTERAPIA COMPORTAMENTALE E COGNITIVA"
,"PSICOTERAPIA COMPORTAMENTALE E COGNITIVISTA"
,"PSICOTERAPIA DELLA FAMIGLIA"
,"PSICOTERAPIA DELLA GESTALT"
,"PSICOTERAPIA DELL'ETA' EVOLUTIVA"
,"PSICOTERAPIA FAMILIARE E RELAZIONALE"
,"PSICOTERAPIA FUNZIONALE"
,"PSICOTERAPIA INDIVIDUALE E DI GRUPPO AD INDIRIZZO ROGERSIANO"
,"PSICOTERAPIA INDIVIDUALE E DI GRUPPO IND. FENOMENOLOGICO-ESISTENZIALE DELLA PSICOLOGIA UMANISTICA"
,"PSICOTERAPIA INTEGRATA"
,"PSICOTERAPIA INTEGRATA DI COMUNITA'"
,"PSICOTERAPIA PROGRAMMAZIONE NEURO LINGUISTICA TERAPEUTICA"
,"PSICOTERAPIA PSICOANALITICA"
,"PSICOTERAPIA PSICOANALITICA DELL'ETA' EVOLUTIVA"
,"PSICOTERAPIA PSICOANALITICA INDIVIDUALE DELL?ADULTO"
,"PSICOTERAPIA PSICODINAMICA INDIVIDUALE E DI GRUPPO"
,"PSICOTERAPIA PSICOSINTETICA ED IPNOSI ERICKSONIANA"
,"PSICOTERAPIA RELAZIONALE"
,"PSICOTERAPIA SISTEMICO-RELAZIONALE"
,"PSICOTERAPIA STRATEGICA AD ORIENTAMENTO NEUROSCIENTIFICO"
,"PSICOTERAPIA TRANSCULTURALE"
,"PSICOTERAPIA TRANSPERSONALE"
,"PSICOTERAPIE BREVI AD APPROCCIO STRATEGICO"
,"PUERICOLTURA"
,"PUERICULTURA"
,"RADIODIAGNOSTICA"
,"RADIODIAGNOSTICA E RADIOTERAPIA"
,"RADIODIAGNOSTICA E SCIENZA DELLE IMMAGINI"
,"RADIODIAGNOSTICA E SCIENZE DELL'IMMAGINE"
,"RADIODIAGNOSTICA IND.IN NEUROLOGIA DIAG.E TERAPEUT."
,"RADIOLOGIA"
,"RADIOLOGIA CON"
,"RADIOLOGIA DIAGNOSTICA"
,"RADIOLOGIA E RADIODIAGNOSTICA"
,"RADIOLOGIA E RADIOTERAPIA"
,"RADIOLOGIA ED ELETTROTERAPIA"
,"RADIOLOGIA MEDICA"
,"RADIOLOGIA MEDICA E TERAPIA FISICA"
,"RADIOLOGIA ONCOLOGICA"
,"RADIOLOGIA ORIENTAMENTO IN RADIODIAGNOSTICA"
,"RADIOLOGIA-DIPLOMA IN RADIOLOGIA DIAGNOSTICA"
,"RADIOLOGIA-ORIENTAMENTO RADIODIAGNOSTICA"
,"RADIOLOGIA-RADIODIAGNOSTICA"
,"RADIOLOGIA-RADIODIAGNOSTICA E SCIENZE DELLE IMMAGINI"
,"RADIOLOGIA-RADIOTERAPIA ONCOLOGICA"
,"RADIOTERAPIA"
,"RADIOTERAPIA ONCOLOGICA"
,"REUMATOLOGIA"
,"RIANIMAZIONE"
,"SCIENZA ALIMENTAZIONE"
,"SCIENZA ALIMENTAZIONE E DIETETICA"
,"SCIENZA DELLA ALIMENTAZIONE-ORIENTAMENTO DIETETICO"
,"SCIENZA DELL'ALIMENTAZIONE"
,"SCIENZA DELL'ALIMENTAZIONE E DIETOLOGIA"
,"SCIENZE MEDICO-DIAGNOSTICHE E TERAPIE SPECIALI"
,"SEMEIOTICA E DIAGNOSTICA DI LABORATORIO"
,"SESSUOLOGIA MEDICA"
,"SICUREZZA ASSISTENZA PREVIDENZA SOCIALE"
,"SICUREZZA SOCIALE E ORGANIZZAZIONE SANITARIA"
,"SPEC. IN ANALISI CLINICHE E SPEC. MED. LABORATOR."
,"STATISTICA MEDICA"
,"STATISTICA MEDICA CON ORIENTAMENTO EPIDEM."
,"STATISTICA MEDICA ORIENTAMENTO CLIN."
,"STATISTICA SANITARIA"
,"STATISTICA SANITARIA E BIOMETRIA"
,"STOMATOLOGIA"
,"STOMATOLOGIA E ODONTOIATRIA"
,"STORIA DELLA MEDICINA"
,"TECNICA E DIAGNOSTICA ISTOPATOLOGICA"
,"TECNICHE SEMEIOLOGICHE CHIRURGICHE"
,"TECNICHE SEMEIOLOGICHE SPECIALE CHIRURGICHE"
,"TECNOLOGIE BIOMEDICHE"
,"TERAPIA CHIRURGICA"
,"TERAPIA FISICA"
,"TERAPIA FISICA E RIABILITAZIONE"
,"TERAPIA MEDICA E RIABILITAZIONE"
,"TERMOGRAFIA A CONTATTO"
,"TISIOLOGIA"
,"TISIOLOGIA DELL'APPARATO RESPIRATORIO"
,"TISIOLOGIA E MALATTIE APPARATO RESPIRATORIO"
,"TISIOLOGIA E MALATTIE DELL'APPARATO RESPIRATORIO"
,"TISIOLOGIA E MALATTIE RESPIRATORIE"
,"TOSSICOLOGIA"
,"TOSSICOLOGIA CLINICA E FARMACOLOGIA"
,"TOSSICOLOGIA FORENSE"
,"TOSSICOLOGIA MEDICA"
,"UROLOGIA"
,"UROLOGIA E ANDROLOGIA"
,"VIROLOGIA"
];
